import React from "react";
import { useDispatch } from "react-redux";
import { MinLoader, TextToolTip } from "components";
import { UploadAvatar } from "./uploadAvatar";
import { ChangePassword } from "./changePassword";
import { FindLoad, isAdmin } from "utils";
import { authActions } from "store";
import { Svg } from "assets";

export const MyProfile = ({ info }) => {
  const dispatch = useDispatch();
  const loader = FindLoad("LOG_OUT");

  const handleSignOut = () => {
    dispatch(authActions.logOut());
  };

  return (
    <div className="my-profile-wrapper">
      {(info?.avatar?.url ||
        info?.firstName ||
        info?.lastName ||
        info?.email) && (
        <div className="my-profile-user-info">
          {(info?.avatar?.url || info?.firstName || info?.lastName) && (
            <div className="my-profile-user-avatar-wrapper">
              {info?.avatar?.url ? (
                <img src={info?.avatar?.url} alt="avatar" />
              ) : (
                (info?.firstName || info?.lastName) && (
                  <p className="my-profile-user-FLName">
                    {`${
                      info?.firstName ? info?.firstName?.[0]?.toUpperCase() : ""
                    } ${info?.lastName ? info?.lastName?.[0]?.toUpperCase() : ""}`}
                  </p>
                )
              )}
            </div>
          )}

          {(info?.firstName || info?.lastName || info?.email) && (
            <div className="my-profile-info-maile">
              {(info?.firstName || info?.lastName) && (
                <TextToolTip
                  classNameText="my-profile-user-flName"
                  content={`${info?.firstName ? info?.firstName : ""} ${info?.lastName ? info.lastName : ""}`}
                  text={`${info?.firstName ? info?.firstName : ""} ${info?.lastName ? info.lastName : ""}`}
                />
              )}

              {info?.email && (
                <TextToolTip
                  classNameText="my-profile-user-email"
                  content={info?.email ? info?.email : "N/A"}
                  text={info?.email ? info?.email : "N/A"}
                />
              )}
            </div>
          )}
        </div>
      )}

      <div className="uploaded-avatar-change-pass-wrapper">
        <UploadAvatar />
        {isAdmin && <ChangePassword />}
      </div>

      <button className="my-profile-log-out-btn" onClick={handleSignOut}>
        {loader?.length ? (
          <MinLoader margin={"0"} color={"#FE7070"} />
        ) : (
          <>
            <Svg.SignOutSvg />
            Log Out
          </>
        )}
      </button>
    </div>
  );
};
